import { SvgWarning } from '../assets/images'
import CustomButton from './CustomButton'
import { Confirmation, NAMESPACE } from '../utils'

interface ConfirmationModalType {
  message: string
  handleNo: () => void
  handleYes: () => void
  cancelButtonLabel?: string
}

const ConfirmationModal = ({
  message,
  handleNo,
  handleYes,
  cancelButtonLabel = Confirmation.CANCEL,
}: ConfirmationModalType) => {
  return (
    <>
      <div className="flex items-center mb-4 justify-center text-sm border-b h-[7.5rem] px-4 font-primary ">
        <div className="flex items-center gap-4">
          <div className="bg-red-100 rounded-full h-[3.625rem] w-[3.625rem] flex items-center justify-center min-w-[3.625rem]">
            <SvgWarning />
          </div>
          <span className="text-base font-light text-accent-700">
            {message}
          </span>
        </div>
      </div>
      {message !== NAMESPACE.DRAFT_DOCUMENT &&
        message !== NAMESPACE.DRAFT_TEMPLATE && (
          <div className="flex gap-3 items-center justify-end !w-full">
            <CustomButton
              onClick={handleNo}
              color="primary"
              className="border border-primary-500 text-xs !w-fit"
            >
              <span className="text-xs text-accent-900 font-light">
                {cancelButtonLabel}
              </span>
            </CustomButton>
            <CustomButton
              onClick={handleYes}
              color="primary"
              isFilled={true}
              className="w-fit"
            >
              {Confirmation.YES}
            </CustomButton>
          </div>
        )}
    </>
  )
}

export default ConfirmationModal
